import React, { useState,useEffect} from 'react';
import { Paper} from '@mui/material';
import {Link} from 'react-router-dom';
import './ArticleTitles.css'
import Title from './Title';
import UmbrellaRainAnimation from './UmbrellaRainAnimation';
import LoadFailed from './LoadFailed';

function ArticleTitles({categoryName,categoryID}) {

    const [titleData, setTitleData] = useState([])
    const [opacity, setOpacity] = useState(0);
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        getTitleData()
    },[categoryID]);

    useEffect(() => {
        let timer;
        if (loading) {
            setOpacity(0); // 重置透明度为 0
            timer = setTimeout(() => {
                setOpacity(1); // 在 25 秒后设置透明度为 1
            }, 25000); // 25 秒
        }
        return () => clearTimeout(timer); // 清理计时器
    }, [loading]); // 监听 loading 状态

    const getTitleData = async () => {
        setLoading(true); // 开始加载
        try {
            const formData = new URLSearchParams();
            formData.append('category', categoryID);

            const res = await fetch('https://api.sadatsunemyspace.uk/api/arctitle', {
                method: 'POST',
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formData.toString()
            });
            const { data } = await res.json();
            setTitleData(data);
        } catch (error) {
            console.error("Error fetching title data:", error);
        } finally {
            setLoading(false); // 加载完成
        }
    };
    
    return (
    <div>
        <Title title={categoryName}></Title>
        {loading ? (
          <center style={{width:'100%'}}>
            <UmbrellaRainAnimation transparent={opacity}/>
          </center>
        ) : (
          titleData.length > 0 ? (
            titleData.map((title) => (
                <Link to={title.link} style={{ textDecoration: 'none' }}>
                <Paper className='articletitlecontainer' elevation={5} sx={{
                    backgroundImage:`
                                linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)),
                                url(${title.tpic})
                                `,
                    backgroundSize:'100%',
                     // 添加过渡效果
                    '&:hover': {
                        backgroundImage: `
                        linear-gradient(rgba(255, 207,205 ,0.8), rgba(255, 207,205 ,0.8)),
                        url(${title.tpic})`,
                        transition: 'background-image 0.5s ease'
                    },
                    marginTop:'10px'
                }}>
                        <p style={{
                            fontFamily:'comicbold',
                            color:'rgba(59,90,155 ,1)'
                        }}>{title.title}</p>
                </Paper>
                </Link>
            ))
          ) : (
            <LoadFailed/>
          )
        )}
        <div style={{height:'20px'}}></div>
    </div>
  );
}

export default ArticleTitles;
